import { Action } from '@ngrx/store';
import { Countries } from '../effects/new-receiving-person.effects';

export enum ReceivingPersonTelephoneCodeActionTypes {
  LOAD_TELEPHONE_CODE = '[Receiving person telephone code] Load telephone code',
  LOAD_TELEPHONE_CODE_COMPLETE = '[Receiving person telephone code] Load telephone code completed',
  LOAD_FAIL_TELEPHONE_CODE = '[Receiving person telephone code] Load fail telephone code',
  RESET = '[Receiving person telephone code] Telephone code reset',
}

export class LoadTelephoneCodeAction implements Action {
  readonly type = ReceivingPersonTelephoneCodeActionTypes.LOAD_TELEPHONE_CODE;

  constructor() {}
}

export class LoadTelephoneCodeCompleteAction implements Action {
  readonly type = ReceivingPersonTelephoneCodeActionTypes.LOAD_TELEPHONE_CODE_COMPLETE;

  constructor(public payload: Countries[]) {}
}

export class LoadFailTelephoneCodeAction implements Action {
  readonly type = ReceivingPersonTelephoneCodeActionTypes.LOAD_FAIL_TELEPHONE_CODE;

  constructor() {}
}

export class ResetTelephonCodeAction implements Action {
  readonly type = ReceivingPersonTelephoneCodeActionTypes.RESET;

  constructor() {}
}

export type TelephoneCodeActions =
  | LoadTelephoneCodeAction
  | LoadTelephoneCodeCompleteAction
  | LoadFailTelephoneCodeAction
  | ResetTelephonCodeAction;
